import type { Campaign, Role, Task, UserProfile } from './types'

const ownerEditableCampaignFields = new Set<keyof Task>(['priority', 'reportArea'])

export function canEditCampaignPanel(role: Role, taskOwner: string, currentUser: string) {
  return role !== 'worker' || taskOwner === currentUser
}

export function canEditAssignedCampaignDetails(role: Role, taskOwner: string, currentUser: string, changes: Partial<Task>) {
  if (role !== 'worker') return true
  return taskOwner === currentUser && Object.keys(changes).every(field => ownerEditableCampaignFields.has(field as keyof Task))
}

export function canDeleteCampaignTask(profile: UserProfile, currentUser: string, campaign?: Campaign) {
  return profile === 'Administrador' || campaign?.createdBy === currentUser
}
